export default __webpack_public_path__ + "static/media/ios_homescreen.8bdd0770.png";